export default "__VITE_ASSET__DB_j$EWA__"